'use client';

import { cn, getColorway } from 'utils/styles';
import Details from 'components/shared/BaseAccordion/Details';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import Summary from 'components/shared/BaseAccordion/Summary';
import { SharedBentoBoxCardProps } from 'types/sharedComponents';
import { getRichTextValue } from 'utils/formatters';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { useState } from 'react';

interface Props extends SharedBentoBoxCardProps {
  isLargeCard?: boolean;
}

const BentoBoxCard = ({ sys, color, cardHeadlineRte, copy, isLargeCard }: Props) => {
  const [open, setIsOpen] = useState(false);

  const hasHeadlineAndCopy = cardHeadlineRte && copy;
  const displayMobileAccordion = hasHeadlineAndCopy;
  const labelText = cardHeadlineRte ? String(getRichTextValue(cardHeadlineRte)) : '';

  const header = (
    <div
      className={cn('font-sans font-semibold text-heading-sm', { 'md:text-heading-xl': isLargeCard })}
      {...liveUpdateAttrs(sys?.id, 'cardHeadlineRte')}>
      <RichTextCopy copy={cardHeadlineRte} />
    </div>
  );
  const body = (
    <div className="font-sans font-medium" {...liveUpdateAttrs(sys?.id, 'cardCopy')}>
      <RichTextCopy copy={copy}></RichTextCopy>
    </div>
  );

  const handleOnClick = (value: boolean) => {
    setIsOpen(value);
  };

  return (
    <div
      className={cn(
        'rounded-lg p-6 h-full sm:aspect-3/2 md:aspect-square sm:col-span-1 col-span-2',
        isLargeCard && 'md:p-12',
        getColorway(color),
      )}>
      <div
        className={cn(displayMobileAccordion && 'hidden sm:flex', 'flex-col justify-between sm:h-full', {
          'h-[11rem]': hasHeadlineAndCopy,
          'h-full': !hasHeadlineAndCopy,
          'h-[11.5rem]': isLargeCard,
        })}>
        {cardHeadlineRte && header}
        {/* This is a spacer to ensure the copy is always placed at the bottom, even if headline is not present*/}
        <div className="grow" />
        {copy && body}
      </div>

      {displayMobileAccordion && (
        <div className="sm:hidden block" data-testid="mobile-bento-card">
          <Details open={open}>
            <Summary
              openIcon="add_circle"
              closeIcon="remove_circle"
              label={labelText}
              isActive={open}
              onClick={handleOnClick}
              data-testid="mobile-bento-card-summary">
              {header}
            </Summary>
            <div className="pt-6" data-testid="mobile-bento-card-copy-wrapper">
              {body}
            </div>
          </Details>
        </div>
      )}
    </div>
  );
};

export default BentoBoxCard;
